// extracted by mini-css-extract-plugin
module.exports = {"disclosureForm":"DisclosureForm_disclosureForm__1bdrC","divider":"DisclosureForm_divider__2H3lT","tabCardContainer":"DisclosureForm_tabCardContainer__1_3N-"};